import { useParams,useLocation } from "react-router";
import TraductionsItemComponent from "../../components/Traductions/TraductionsItem";
import { useTraductionsByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";

function TraductionsItem(){
    const location = useLocation();
    const state= location.state as LocationState | undefined;
    const params = useParams();
    const { data:traduction, error, isLoading } = useTraductionsByIdQuery(params.id??"0");
    const {translate}=useTrads();
    return (

        
        error ?<p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        traduction &&
        <>
          {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_traduction_update')}</p>}
          <TraductionsItemComponent traduction={traduction}  />
        
        </>

    );
}
export default TraductionsItem;